import { render, staticRenderFns } from "./WrapperCollapse.vue?vue&type=template&id=4fd8aca3"
import script from "./WrapperCollapse.vue?vue&type=script&lang=js"
export * from "./WrapperCollapse.vue?vue&type=script&lang=js"
import style0 from "./WrapperCollapse.vue?vue&type=style&index=0&id=4fd8aca3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports